import { AlertTriangle, CalendarClock, Repeat, Zap } from "lucide-react";
import { JOB_STATUS, PRIORITY, TYPE, whenLabel } from "@/lib/jobs";

export const TypeBadge = ({ t, big }) => (
  <span className={`inline-flex items-center rounded-full font-bold text-white ${big ? "px-4 py-1.5 text-base" : "px-2.5 py-0.5 text-xs"}`} style={{ background: TYPE[t]?.color }}>{TYPE[t]?.label || t}</span>
);

export const StatusChip = ({ s, testid }) => {
  const [l, c] = JOB_STATUS[s] || [s, ""];
  return <span data-testid={testid} className={`inline-flex rounded-full px-2.5 py-0.5 text-xs font-bold ${c}`}>{l}</span>;
};

export const PriorityChip = ({ p }) => (p === "routine" ? null : <span className={`rounded-full px-2.5 py-0.5 text-xs font-black uppercase ${p === "emergency" ? "bg-red-600 text-white" : "bg-orange-500/20 text-orange-500"}`}>{PRIORITY[p]}</span>);

export const WhenChip = ({ j, big }) => {
  const sz = big ? "px-3 py-1 text-sm" : "px-2.5 py-0.5 text-xs";
  return (
    <>
      {j.when === "scheduled" && j.scheduled_for
        ? <span className={`inline-flex items-center gap-1 rounded-full bg-sky-600 font-bold text-white ${sz}`} data-testid={`when-prebooked-${j.id}`}><CalendarClock className="h-3.5 w-3.5" />Pre-booked · {whenLabel(j.scheduled_for)}</span>
        : <span className={`inline-flex items-center gap-1 rounded-full bg-red-600 font-black text-white ${sz}`} data-testid={`when-asap-${j.id}`}><Zap className="h-3.5 w-3.5" />ASAP</span>}
      {j.deliver_by && <span className={`rounded-full border border-sky-500 font-bold text-sky-500 ${sz}`}>Arrive by {whenLabel(j.deliver_by)}</span>}
      {j.series_id && <span className={`inline-flex items-center gap-1 rounded-full border font-bold ${sz}`} data-testid={`repeat-${j.id}`}><Repeat className="h-3.5 w-3.5" />Repeat</span>}
      {j.tight && <span className={`inline-flex items-center gap-1 rounded-full bg-amber-500 font-bold text-black ${sz}`} data-testid={`tight-${j.id}`}><AlertTriangle className="h-3.5 w-3.5" />Tight timing</span>}
    </>
  );
};
